import type { DemoMetadata } from "@/registry/types";

export const metadata: DemoMetadata = {
  id: "micro-frontends",
  name: "microFrontends.name",
  description: "microFrontends.description",
  longDescription: "microFrontends.longDescription",
  category: "shared.categories.architecture",
  tags: "microFrontends.tags",
  featured: false,
  status: "coming-soon",
  architecture: "microFrontends.architecture",
  technologies: "microFrontends.technologies",
  concepts: "microFrontends.concepts",
  i18nNamespace: "microFrontends",
};
